// eslint-disable-next-line no-restricted-syntax
export enum EntryType {
  MULTI_ENTRY = 'multientry',
  SINGLE_ENTRY = 'singleentry',
}
